import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data.user);
        return data.user;
    };
    const register = async (name, email, password, acceptTerms = false) => {
        const { data } = await api.post("/auth/register", { name, email, password, accept_terms: acceptTerms });
        setUser(data.user);
        return data.user;
    };
    const logout = async () => {
        await api.post("/auth/logout");
        setUser(null);
    };

    const forgotPassword = async (email) => {
        const { data } = await api.post("/auth/forgot-password", { email });
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, forgotPassword }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
